import React from 'react';
import { Row, Col } from 'style';
import { Calendar, TextAreaStandart } from 'components/elements';
import TableGrid from 'components/tableGrid/TableGrid.js';

import { getFA_ProductDeliveryPeriod, updateFA_ProductDeliveryPeriod, deleteFA_ProductDeliveryPeriod, createFA_ProductDeliveryPeriod } from '../../gql/index';

import { useTranslation } from 'react-i18next';

export default (props) =>{
  const [t] = useTranslation();
  // const { data, loading, client } = useQuery(listCompareFa_Assortment, { variables: { id: +props.linkId } });
  // const [MUTATION_changeCompareFa_Assortment] = useMutation(changeCompareFa_Assortment);
    
  const tableData = [
    {
      name: t('common.fromDate'),
      dataBase: 'fromDate',
      isMutation: true,
      dataType: 'date',
      isRequired: true,
    },
    {
      name: t('common.toDate'),
      dataBase: 'toDate',
      isMutation: true,
      dataType: 'date',
      isRequired: true,
    },
    {
      name: t('common.note'),
      dataBase: 'name',
      isMutation: true,
    },
  ];

  const Component = (props) => {
    const { values, setFieldValue, handleChange, errors, touched } = props;
    return(
      <div>
        <Row>
          <Col lg={3}>
            <Calendar withoutFormik={true} title={t('common.fromDate')} setFieldValue={setFieldValue} name='fromDate' value={values.fromDate}/>
            {(errors?.fromDate && touched?.noActiveBtnClick) && <p style={{ color: 'red' }}>{errors?.fromDate}</p>}
          </Col>
          <Col lg={3}>
            <Calendar withoutFormik={true} title={t('common.toDate')} setFieldValue={setFieldValue} name='toDate' value={values.toDate}/>
            {((errors?.toDate && touched?.noActiveBtnClick) || errors?.toDate && Date.parse(props.values?.toDate) < Date.parse(props.values?.fromDate)) &&
              <p style={{ color: 'red' }}>{errors?.toDate}</p>
            }
          </Col>
        </Row>
        <TextAreaStandart
          withoutFormik={true}
          type='text'
          onChange={handleChange}
          value={values.name}
          name={'name'}
          title={t('common.note')}
          width='100%'
        />
      </div>
    );
  };

  return (
    <TableGrid
      withSearch
      itemDeleted={deleteFA_ProductDeliveryPeriod}
      graphqlParams={{
        query: getFA_ProductDeliveryPeriod,
        variables: { productLink: +props.id,
          isVacation: true,
        },
      }}
      // addNewItem = {addNewItem}
      // editItem={editItem}
      //onDelete = {onDelete}
      //searchValue={this.state.searchValue}
      //onSearch={this.onSearch}
      //getSortField={this.getSortField}
      tableData={tableData}
      //getTableIndex={this.indexOnClickTable}
      Component={Component}
      height={300}
      headerText={t('customer.breakOff')}
      modalWidth={550}
      modalHeight={370}
      withModalMutations
      defaultValuesForMutation = {{ isVacation: true,
        productLink: +props.id,
        isCustomWeekDaySetting: false,
        isMonday: false,
        isTuesday: false,
        isWednesday: false,
        isThursday: false,
        isFriday: false,
        isSaturday: false,
        isSunday: false,
        isRepeatYearly: false }}
      typeName={'FA_ProductDeliveryPeriod'}
      qqlMutationCreate={createFA_ProductDeliveryPeriod}
      qqlMutationUpdate={updateFA_ProductDeliveryPeriod}
    />
  );
};


